import React, { useCallback } from 'react';
import { useMappedState } from 'redux-react-hook';
import _size from 'lodash/size';
import { STRINGS } from 'config';
import { Text } from 'styles/elements/text';
import { SingleSelect } from './singleSelect';
import { MultipleSelect } from './multipleSelect';
import { DateField } from './date';
import { FreeText } from './freeText';
import { FreeTextShort } from './freeTextShort';
import { Compound } from './compound';
import { BloodPressure } from './bloodPressure';
import { BodyMassIndex } from './bodyMassIndex';
import { PhotoUpload } from './photoUpload';
import { Login } from './login';
import { Search } from './search';

export function Answer({ question, isMounted, onClickNextQuestion, questionContainerRef, isGuidanceTextShownAboveQuestion }) {
  const mapState = useCallback(state => ({
    validationErrors: state.consultationReducer.validationErrors,
  }), []);
  const { validationErrors } = useMappedState(mapState);

  const isInvalid = _size(validationErrors) >= 1;

  switch (question.type) {
    case (STRINGS.QUESTION_TYPE.SINGLE):
      return <SingleSelect question={question} isMounted={isMounted} isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion} />;
    case (STRINGS.QUESTION_TYPE.MULTIPLE):
      return (
        <MultipleSelect
          question={question}
          isMounted={isMounted}
          onClickNextQuestion={onClickNextQuestion}
          isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion}
        />
      );
    case (STRINGS.QUESTION_TYPE.ALLMULTIPLE):
      return (
        <MultipleSelect
          question={question}
          isMounted={isMounted}
          onClickNextQuestion={onClickNextQuestion}
          isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion}
        />
      );
    case (STRINGS.QUESTION_TYPE.DATE):
      return <DateField isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.FREETEXT):
      return (
        <FreeText
          isInvalid={isInvalid}
          questionId={question.questionId}
          questionText={question.text}
          questionGuidanceScript={question.guidanceScript}
          isMounted={isMounted}
          onClickNextQuestion={onClickNextQuestion}
          isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion}
        />
      );
    case (STRINGS.QUESTION_TYPE.FREETEXTSHORT):
      return (
        <FreeTextShort
          isInvalid={isInvalid}
          isMounted={isMounted}
          onClickNextQuestion={onClickNextQuestion}
          isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion}
        />
      );
    case (STRINGS.QUESTION_TYPE.TIME):
      return <FreeTextShort isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.WEIGHT):
      return <FreeTextShort isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.HEIGHT):
      return <FreeTextShort isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.COMPOUND):
      return <Compound question={question} isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} validationErrors={validationErrors} />;
    case (STRINGS.QUESTION_TYPE.BLOODPRESSURE):
      return <BloodPressure questionId={question.questionId} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.BODYMASSINDEX):
      return <BodyMassIndex questionId={question.questionId} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.PHOTO):
      return (
        <PhotoUpload
          onClickNextQuestion={onClickNextQuestion}
          questionId={question.questionId}
          questionContainerRef={questionContainerRef}
          questionTags={question.tags}
        />
      );
    case (STRINGS.QUESTION_TYPE.LOGIN):
      return <Login onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.SEARCH):
      return <Search questionId={question.questionId} questionText={question.questionText} isInvalid={isInvalid} isMounted={isMounted} onClickNextQuestion={onClickNextQuestion} />;
    case (STRINGS.QUESTION_TYPE.ENDSTATE):
      return <div />;
    default:
      return (
        <Text>
          Question type {question.type} not recognised
        </Text>
      );
  }
}
